module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "legals-layout take-place column"
  }, [_c('div', {
    staticClass: "legals-master column"
  }, [_c('div', {
    staticClass: "legals-title"
  }, [_vm._v("\n\t\t\tMentions Légales\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "legals-body"
  }, [_c('div', {
    staticClass: "legals-section-title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Éditeur du site internet")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Ce site internet est édité par la société Patrimoffice, Société par Actions Simplifiée (SAS) au capital de 1.800,00 € entièrement libéré (SIREN : 829 888 122 R.C.S. Paris). Son siège social est au 7 avenue Ingres, 75016 Paris.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Numéro de TVA intracommunautaire : FR07829888122.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Mail de contact : contact@patrimoffice.com.")]), _vm._v(" "), _c('div', {
    staticClass: "legals-section-title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Directeur de la publication")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Olivier Potellet.")]), _vm._v(" "), _c('div', {
    staticClass: "legals-section-title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Hébergement")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Le site patrimoffice.com est hébergé par la société Amazon Web Services, Inc., dont le siège social est situé P.O. Box 81226 Seattle, WA 98108-1226 (https://aws.amazon.com).")]), _vm._v(" "), _c('div', {
    staticClass: "legals-section-title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Propriété intellectuelle")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Ce site internet et l'ensemble de ses contenus, tels que notamment, sans que cette liste ne soit limitative, les textes, informations, documentations, documents sonores, photographies, dessins, plans, marques, progiciels, logiciels, données, bases de données, charte graphique, visuels, avatars, et plus généralement tout élément apparaissant sur le site internet, sont protégés par le droit de la propriété intellectuelle et sont la propriété exclusive de Patrimoffice.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aae4c3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Legal/Legals.vue
// module id = 1153
// module chunks = 0